import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OnDemandPreloadingStrategy } from './core/services/on-demand-preloading.service';
import { SummaryComponent } from '@/app/summary';
import { CallbackComponent } from './callback/callback.component';
import { AuthGuard } from '@/app/core';
import { SignoutComponent } from './signout/signout.component';
import { DownloadsComponent } from './downloads';
import { DownloadComponent } from './download';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { ProductTypeDashboardComponent } from './equipment';
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';

const enableTracing = false;

const routes: Routes = [
  {
    path: '',
    component: SummaryComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'summary',
    component: SummaryComponent,
    data: { title: 'main.tabs.summary.page_title' },
  },
  {
    path: 'unsubscribe',
    component: UnsubscribeComponent,
    data: { title: 'main.tabs.unsubscribe.page_title' },
  },
  {
    path: 'summary',
    component: SummaryComponent,
    canActivate: [AuthGuard],
    data: { title: 'main.tabs.summary.page_title' },
  },
  {
    path: 'summary/:ccm',
    component: SummaryComponent,
    canActivate: [AuthGuard],
    data: { title: 'main.tabs.summary.page_title' },
  },
  {
    path: 'callback',
    component: CallbackComponent,
    data: { title: 'main.navigation.page_titles.callback' },
  },
  {
    path: 'signout',
    component: SignoutComponent,
    data: { title: 'main.navigation.page_titles.signout' },
  },
  {
    path: 'downloads',
    component: DownloadsComponent,
    data: { title: 'main.tabs.downloads.page_titles.root' },
  },
  {
    path: 'download/:filename',
    component: DownloadComponent,
    data: { title: 'main.tabs.downloads.page_titles.download' },
  },
  {
    path: 'custom-grids',
    loadChildren: () =>
      import('./custom-grids/custom-grids.module').then(
        (m) => m.CustomGridsModule
      ),
    canActivate: [AuthGuard],
    data: { title: 'main.tabs.custom_grids.page_titles.root' },
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./modules/admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard],
    data: { title: 'main.tabs.custom_grids.page_titles.root' },
  },
  /*{
    path: 'custom-grids',
    component: CustomGridsComponent,
    canActivate: [AuthGuard],
    data: { title: 'main.tabs.custom_grids.page_titles.root' },
  },*/
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    data: { title: 'main.navigation.page_titles.unauthorized' },
  },
  {
    path: 'equipment',
    component: ProductTypeDashboardComponent,
    data: {
      title: 'main.tabs.equipment.product_types.page_titles.root',
      mainClass: 'locked',
    },
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing,
      preloadingStrategy: OnDemandPreloadingStrategy,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
